<br>
<div class="inicio">
  <form #insertForm="ngForm" [formGroup]="formResponsiva">
    <br>
    <!--DATOS DE LA PERSONA QUE SUSCRIBE LA RESPONSIVA-->
    <div class="div">
      <p> DATOS DEL QUE SUSCRIBE LA RESPONSIVA</p>
      <div class="grid-containerB">
        <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="regresar()"> <span
            class="material-icons">undo</span> </button>
      </div>
      <br>
      <div class="requerido"> <mat-label>* Campos requeridos </mat-label> </div>
      <div class="grid-container">

        <!--Nombre del que suscribe-->
        <div class="celda">
          <mat-label class="label">Nombre <mat-label class="requerido">*</mat-label></mat-label>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="colaboradorFilter" #singleSelect1 (selectionChange)="cargarDatosSuscribe($event)"
              required>
              <mat-option>
                <ngx-mat-select-search debounceInput (onEventDebounce)="buscarEmpleado($event)"
                  oninput="this.value ? this.value = this.value.toUpperCase() : null">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of listaColaboradores" [value]="option">
                {{option.nomb_compl}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="this.colaboradorFilter.value=='' ">
              El nombre del colaborador es requerido
            </mat-error>
          </mat-form-field>
        </div>

        <!--Cargo del que suscribe-->
        <div class="celda">
          <mat-label class="label"> Cargo que ocupa <mat-label class="requerido">*</mat-label> </mat-label>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Seleccione el cargo que ocupara el que suscribe" formControlName="puesto_suscribe"
              required>
              <mat-option>
                <ngx-mat-select-search debounceInput (onEventDebounce)="buscarPuesto($event)"
                  oninput="this.value ? this.value = this.value.toUpperCase() : null">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                  <span ngxMatSelectNoEntriesFound>
                    No se encontraron opciones
                  </span>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let puesto of listaCargos" [value]=puesto.nombrePuesto>{{ puesto.nombrePuesto }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="grid-container2">
        <div></div>
        <button mat-raised-button [disabled]="!habilitarBotonResponsiva()|| descargando" (click)="descargarResponsiva()"
          color="primary">
          <span *ngIf="!descargando"
            style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
            Descargar Responsiva <mat-icon>file_download</mat-icon>
          </span>
          <mat-spinner *ngIf="descargando" diameter="20"></mat-spinner>
        </button>
        <div></div>
        <button mat-raised-button *ngIf="solicitaSimbanck" [disabled]="descargando"
          (click)="descargarCartaResponsiva() " color="primary">
          <span *ngIf="!descargando"
            style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
            Descargar Carta Responsiva <mat-icon>file_download</mat-icon>
          </span>
          <mat-spinner *ngIf="descargando" diameter="20"></mat-spinner>
        </button>
      </div>
    </div>
  </form>
</div>